export default "__VITE_ASSET__CXo522Wh__"